(function ($) {

	$.ZagParallax = function (element, options) {

		options = $.extend({}, $.ZagParallax.defaultOptions, options);

		var Component = element;
		Component.addClass("zag-parallax");

		if (Component.children(".zag-parallax-bg").length) {

			var Background = Component.children(".zag-parallax-bg");

			$(window).on("load scroll resize", function () {

				var bgHeight = ($(window).height() - Component.outerHeight()) / options.divisor + Component.outerHeight();
				var bgTop = ($(window).scrollTop() - Component.offset().top) / options.divisor;

				Background.height(bgHeight);
				Background.css({ marginTop: bgTop });
			});
		}
	};

	$.fn.ZagParallax = (function (options) {
		return this.each(function () {
			(new $.ZagParallax($(this), options));
		});
	});

	$.ZagParallax.defaultOptions = { divisor: 1 };

})(jQuery);